import { NgModule } from '@angular/core';
import { TruncateStringPartsPipe } from './truncate-string-parts';

@NgModule({
  declarations: [ TruncateStringPartsPipe ],
  exports: [ TruncateStringPartsPipe ],
})
export class TruncateStringPartsPipeModule {}
